import * as Scrivito from "scrivito";
import React from "react";
import { Select } from "components";
import { useProjectListContext } from "../../hooks/useProjectListContext";

type DepartmentOption = {
  value?: string;
  label?: string | null;
};

export const DepartmentDropdown = Scrivito.connect(() => {
  const { selectedDepartment, setSelectedDepartment, departmentOptions } =
    useProjectListContext();

  const handleSelectDepartment = (dept: DepartmentOption | null) => {
    if (!dept) return;

    if (dept.value !== selectedDepartment?.value) {
      setSelectedDepartment(dept);
      Scrivito.navigateTo(() => Scrivito.currentPage(), {
        params: { page: "1" },
      });
    }
  };

  return (
    <div className="col-3">
      <div className="d-flex text-gray-700 fw-bold">Department</div>
      <Select
        onChange={handleSelectDepartment}
        options={departmentOptions as DepartmentOption[]}
        value={selectedDepartment}
        name="departmentSelect"
        testId="department-select"
      />
    </div>
  );
});
